function isRendered(element) {
  return element.offsetParent !== null;
}
function textNodeExists(text) {
  var _a;
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  let node;
  while (node = walker.nextNode()) {
    if (((_a = node.textContent) == null ? void 0 : _a.trim().includes(text)) && node.parentElement && isRendered(node.parentElement)) {
      return true;
    }
  }
  return false;
}
export function waitForDomText(condition, onSatisfied, onTimeout) {
  const start = Date.now();
  let timedOut = false;
  const interval = window.setInterval(() => {
    if (textNodeExists(condition.text)) {
      window.clearInterval(interval);
      onSatisfied();
      return;
    }
    if (!timedOut && Date.now() - start > condition.timeoutMs) {
      timedOut = true;
      onTimeout();
    }
  }, condition.pollMs);
  return () => window.clearInterval(interval);
}
